export enum TooltipPlacement {
    bottom = 'bottom',
    top = 'top',
    left = 'left',
    right = 'right',
    topRight = 'top-start',
    topLeft = 'top-end',
    bottomRight = 'bottom-start',
    bottomLeft = 'bottom-end',
}
